angular.module('tgaAdmin')
  .service('productService', ['$http', 'envService',
    function ($http, envService) {
      const serverAddress = envService.read('serverAddress');

      function getProducts() {
        return $http({
          method: 'GET',
          url: `${serverAddress}product`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getCoupons() {
        return $http({
          method: 'GET',
          url: `${serverAddress}coupon`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getCoupon(coupon_id) {
        return $http({
          method: 'GET',
          url: `${serverAddress}coupon/${coupon_id}`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function addCoupon(data) {
        return $http({
          method: 'POST',
          url: `${serverAddress}coupon`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function updateCoupon(data) {
        return $http({
          method: 'PUT',
          url: `${serverAddress}coupon/${data.coupon_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function deleteCoupon(data) {
        return $http({
          method: 'DELETE',
          url: `${serverAddress}coupon/${data.coupon_id}`,
          data,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getAffiliates() {
        return $http({
          method: 'GET',
          url: `${serverAddress}coupon/affiliates`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getSalespersons() {
        return $http({
          method: 'GET',
          url: `${serverAddress}coupon/salespersons`,
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      function getTaxRate(postalCode) {
        return $http({
          method: 'GET',
          url: 'https://sandbox-rest.avatax.com/api/v2/taxrates/bypostalcode',
          headers: {
            Authorization: 'Basic MjAwMTQzODM4OTpBREMzOTg2Mjg3NEUxQkEy',
          },
          params: {
            country: 'US',
            postalCode,
          },
        }).then(
          (response) => response.data,
          (error) => {
            throw error.data;
          },
        );
      }

      return ({
        getProducts,
        getCoupons,
        getCoupon,
        addCoupon,
        updateCoupon,
        deleteCoupon,
        getAffiliates,
        getSalespersons,
        getTaxRate,
      });
    }]);
